import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiUrlService } from '../shared-services/api-url.service';

@Injectable({
  providedIn: 'root'
})
export class ActivityLogService {

  constructor(private apiUrlService:ApiUrlService, private http:HttpClient) { }


  getAPIactivityLogs(payload: any):Observable<any> {
    let param = new HttpParams();
    param = param.append('limit',payload.limit);
    param = param.append('currentPage',payload.currentPage)
    param = param.append('search',payload.search)
    param = param.append('startDate',payload.startDate)
    param = param.append('endDate',payload.endDate)
    return this.http.get<any>(`${this.apiUrlService.GET_API_LOGS}`, { params: param});
  }

  
  getCallBackLogs(payload: any):Observable<any> {
    let param = new HttpParams();
    param = param.append('limit',payload.limit);
    param = param.append('currentPage',payload.currentPage)
    param = param.append('MERCHANTID', ""),
    param = param.append('MOPTYPE', ""),
    param = param.append('ACQID', "");
    param = param.append('search',payload.search);
    param = param.append('startDate',payload.startDate)
    param = param.append('endDate',payload.endDate)
    return this.http.get<any>(`${this.apiUrlService.GET_CALLBACK_LOG}/callback`, { params: param});
  }

}
